import { render, staticRenderFns } from "./FolioTestActions.vue?vue&type=template&id=68d80e23&"
import script from "./FolioTestActions.vue?vue&type=script&lang=js&"
export * from "./FolioTestActions.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports